/**
 * Created by jv on 2019-10-01 (14:21).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";

const CloseSvgIcon = require("!raw-loader!Images/icons/btn_plus.svg");

require("Styles/components/business-model-dialog.scss");
require("Styles/components/close-round-dialog.scss");

class CloseRoundDialog {
  constructor(options) {
    this.dialogId = utils.generateElementId("close-round-dialog-");

    this._roundOverview = options.roundOverview;

    this.callbackContext = options.callbackContext;
    this.onCancel = options.onCancel;
    this.onViewInvestments = options.onViewInvestments;
    this.onCloseRound = options.onCloseRound;
  }

  get roundOverview() {
    return this._roundOverview;
  }

  set roundOverview(roundOverview) {
    this._roundOverview = roundOverview;
    this.renderDialogContent();
  }

  get currentRoundData() {
    return this.roundOverview.currentRoundData;
  }

  get isOpen() {
    return utils.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
  }

  create() {
    if (this._initialized !== true) {
      this.renderDialog();

      this.$dialog.appendTo("body");
      this.initialize();
    }
  }

  initialize() {
    if (this._initialized !== true) {
      this.$dialog.modal({
        backdrop: false,
        show: false
      });

      this.setUpDialogEventListeners();

      this._initialized = true;
    }
  }

  renderDialog() {
    this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" +
      "<div class='modal-dialog modal-dialog-centered business-model-dialog close-round-dialog'>" +
      "<div class='modal-content'>" +
      "</div>" +
      "</div>" +
      "</div>");

    this.renderDialogContent();
  }

  renderDialogContent() {
    if (utils.isNull(this.currentRoundData)) return;

    let $dialogContent = this.$dialog.find(".modal-content");

    if (utils.isNotNull($dialogContent) && $dialogContent.length) {
      $dialogContent.empty();

      log.debug("Setting up close round dialog card - %o", this.currentRoundData);

      let $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
      $closeBtn.html(CloseSvgIcon);
      $dialogContent.append($closeBtn);

      let $closeRoundContent = $("<div class='crd__content'></div>");

      let $closeRoundTop = $("<div class='crd__top'></div>");

      $closeRoundTop.append(`<h6 class='crd__title'>${LanguageManager.getValueForKey("serious_game.business_model.close_round.dialog.title")}</h6>`);

      if (utils.isNull(this.currentRoundData.investmentKey1)) {
        $closeRoundTop.append(`<p>${LanguageManager.getValueForKey("serious_game.business_model.close_round.dialog.text.2")}</p>`);
      } else if (utils.isNull(this.currentRoundData.investmentKey2)) {
        $closeRoundTop.append(`<p>${LanguageManager.getValueForKey("serious_game.business_model.close_round.dialog.text.1")}</p>`);
      } else {
        $closeRoundTop.append(`<p>${LanguageManager.getValueForKey("serious_game.business_model.close_round.dialog.text.0")}</p>`);
      }

      $closeRoundContent.append($closeRoundTop);

      let $closeRoundActions = $("<div class='crd__actions'></div>");

      if (utils.isNull(this.currentRoundData.investmentKey2)) {
        $closeRoundActions.append(`<button class='btn btn-outline-c-green btn-lg btn-block view-investments-btn' type='button'>${LanguageManager.getValueForKey("serious_game.business_model.close_round.dialog.actions.investments")}</button>`);
      }

      $closeRoundActions.append(`<button class='btn btn-outline-c-light-blue btn-lg btn-block close-round-btn' type='button'>${LanguageManager.getValueForKey("serious_game.business_model.close_round.dialog.actions.close_round")}</button>`);

      $closeRoundContent.append($closeRoundActions);

      $dialogContent.append($closeRoundContent);

      this.setUpCloseRoundEventListeners();
    }
  }

  setCloseRoundButtonLoading(flag) {
    let $closeRoundBtn = this.$dialog.find(".close-round-btn");
    $closeRoundBtn.removeClass("btn-loading").prop("disabled", flag);

    if (flag) {
      $closeRoundBtn.addClass("btn-loading");
    }
  }

  show() {
    this.setCloseRoundButtonLoading(false);
    this.$dialog.modal("show");
  }

  hide() {
    this.$dialog.modal("hide");
  }

  setUpDialogEventListeners() {

  }

  setUpCloseRoundEventListeners() {
    this.$dialog.find(".btn").on("transitionend", (e) => {
      // transitionend fix for dialog close animations
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    this.$dialog.find(".dialog-close-btn").on("click", (e) => {
      if (utils.isFunction(this.onCancel)) {
        this.onCancel.call(this.callbackContext, this);
      }
    });

    this.$dialog.find(".view-investments-btn").on("click", (e) => {
      if (utils.isFunction(this.onViewInvestments)) {
        this.onViewInvestments.call(this.callbackContext, this);
      }
    });

    this.$dialog.find(".close-round-btn").on("click", (e) => {
      if (utils.isFunction(this.onCloseRound)) {
        this.onCloseRound.call(this.callbackContext, this);
      }
    });
  }
}

export default CloseRoundDialog;



// WEBPACK FOOTER //
// ./app/js/components/game/components/close-round-dialog.js